export const AUTH = {
  LOGIN_WITH_EMAIL: {
    REQUEST: "LOGIN_WITH_EMAIL.REQUEST",
    SUCCESS: "LOGIN_WITH_EMAIL.SUCCESS",
    FAILURE: "LOGIN_WITH_EMAIL.FAILURE",
  },
  LOGOUT: {
    REQUEST: "LOGOUT.REQUEST",
    SUCCESS: "LOGOUT.SUCCESS",
    FAILURE: "LOGOUT.FAILURE",
  },
  REGISTER_WITH_EMAIL: {
    REQUEST: "REGISTER_WITH_EMAIL.REQUEST",
    SUCCESS: "REGISTER_WITH_EMAIL.SUCCESS",
    FAILURE: "REGISTER_WITH_EMAIL.FAILURE",
  },
  GET_USER: {
    REQUEST: "GET_USER.REQUEST",
    RESOLVED: "GET_USER.RESOLVED",
    REJECTED: "GET_USER.REJECTED",
  },
  CREATE_USER_DB: "CREATE_USER_DB",
  CREATE_USER_DB_FAILURE: "CREATE_USER_DB.FAILURE",
};
